
import { BaseResponseDto, DeleteVolunteerRequest, GetVolunteerFilter, PostVolunteerRequest, PutVolunteerRequest, Volunteer } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const volunteersActions = createActionGroup({
    source: 'Volunteers',
    events: {
        ['[Volunteer - API] Load volunteer']: props<{ paylod: GetVolunteerFilter }>(),
        ['[Volunteer - API] Load success']: props<BaseResponseDto<Volunteer.VolunteerListDto>>(),
        ['[Volunteer - API] Load failed']: props<BaseResponseDto<Volunteer.VolunteerListDto>>(),
        ['[Volunteer - API] Create volunteer']: props<PostVolunteerRequest>(),
        ['[Volunteer - API] Update volunteer']: props<PutVolunteerRequest>(),
        ['[Volunteer] Update volunteer']: props<Volunteer.VolunteerDto>(),
        ['[Volunteer] - API] Delete volunteer']: props<DeleteVolunteerRequest>(),
        [`[Volunteer - API] Reset volunteer`]: emptyProps()

    }
})

// export const loadFromApiVolunteer = createAction(`[Volunteer - API] Load volunteer`, props<GetVolunteerFilter>());
// export const loadVolunteerSucces = createAction('[Volunteer - API] Load success', props<BaseResponseDto<Volunteer.VolunteerListDto>>())
// export const loadVolunteerFailed = createAction('[Volunteer - API] Load failed', props<BaseResponseDto<Volunteer.VolunteerListDto>>())
// export const createFromApiVolunteer = createAction(`[Volunteer - API] Create volunteer`, props<
// export const updateFromApiVolunteer = createAction(`[Volunteer - API] Update volunteer`, props<
// export const updateVolunteerItem = createAction(`[Volunteer] Update volunteer`, props<Volunteer.VolunteerDto>());
// export const deleteFromApiVolunteer = createAction(`[Volunteer - API] Delete volunteer`, props<
// export const resetVolunteer = createAction(`[Volunteer - API] Reset volunteer`);
